module.exports = __webpack_public_path__ + "995e94bfe44ec3a9ceb9b7a69c526c6f.pdf";